import { AlphaHBoxOutlineIcon } from './AlphaHBoxOutlineIcon';

/**
 * author: Contributors
 * id 7568D810-145E-41E7-8447-E2257339D5D8
 * name alpha-h-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-h-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetHBoxOutlineIcon = AlphaHBoxOutlineIcon;
export default AlphabetHBoxOutlineIcon